import { isArray, isEmpty, isObject, isString, isEqual } from 'lodash/lang'
import { reduce } from 'lodash/collection'
import { transform } from 'lodash/object'
import { helpers } from 'vuelidate/lib/validators'
import moment from 'moment-timezone'
import { AND_SEPARATOR, OR_SEPARATOR } from './axios'

export const registerRoutes = (router, routes) => {
  routes.forEach((route) => router.addRoute(route))
}

export const registerStore = (store, ns, nsStore) => {
  store.registerModule(ns, nsStore)
}

export const registerMessages = (i18n, messages) => {
  Object.keys(messages).forEach((key) => {
    i18n.mergeLocaleMessage(key, messages[key])
  })
}

export const registerLauncherItems = (store, launcherItems) => {
  if (isArray(launcherItems) && !isEmpty(launcherItems)) {
    store.dispatch('app/addLauncherItems', launcherItems)
  }
}

export const registerHeaderItems = (store, headerItems) => {
  if (isArray(headerItems) && !isEmpty(headerItems)) {
    store.dispatch('app/addHeaderItems', headerItems)
  }
}

export const registerNavItems = (store, navItems) => {
  if ((isObject(navItems) || isArray(navItems)) && !isEmpty(navItems)) {
    store.dispatch('app/addNavItems', navItems)
  }
}

export const registerModule = (router, store, i18n, opts = {}) => {
  // opts: routes, namespace, namespaceStore, messages, navItems, headerItems
  if (isObject(router) && isArray(opts.routes) && !isEmpty(opts.routes)) {
    registerRoutes(router, opts.routes)
  }
  if (isObject(store) && isObject(opts.namespaceStore) && !isEmpty(opts.namespaceStore)) {
    if (isString(opts.namespace) && !isEmpty(opts.namespace)) {
      registerStore(store, opts.namespace, opts.namespaceStore)
    } else {
      console.error('Please provide a namespace for store registration.')
    }
  }
  if (isObject(i18n) && isObject(opts.messages) && !isEmpty(opts.messages)) {
    registerMessages(i18n, opts.messages)
  }
  if (isObject(store) && isObject(opts.launcherItems) && !isEmpty(opts.launcherItems)) {
    registerLauncherItems(store, opts.launcherItems)
  }
  if (isObject(store) && isObject(opts.headerItems) && !isEmpty(opts.headerItems)) {
    registerHeaderItems(store, opts.headerItems)
  }
  if (isObject(store) && isObject(opts.navItems) && !isEmpty(opts.navItems)) {
    registerNavItems(store, opts.navItems)
  }
}

export const registerError404 = (router) => {
  router.beforeEach((to, from, next) => {
    if (!to.matched.length) {
      next('/errors/404')
    } else {
      next()
    }
  })
}

export const formatDT = (datetime, opts) => {
  const options = opts || {}
  const locale = options.locale || 'en'
  const format = options.format || 'L LTS'
  const timezone = options.tz || 'Canada/Eastern'
  moment.locale(locale)
  moment.tz.setDefault('UTC')
  return moment(datetime).tz(timezone).format(format)
}

export const formatTS = (timestamp, opts) => {
  const options = opts || {}
  const locale = options.locale || 'en'
  const format = options.format || 'L LTS'
  const timezone = options.tz || 'Canada/Eastern'
  moment.locale(locale)
  moment.tz.setDefault('UTC')
  return moment.unix(timestamp).tz(timezone).format(format)
}

export const objectToArray = (obj) => {
  const compress = (result, value, key) => [...result, { ...value, name: key }]
  return reduce(obj, compress, [])
}

export const diffObjects = (obj, target) => {
  return transform(
    obj,
    (result, value, key) => {
      if (!isEqual(value, target[key])) {
        result[key] = isObject(value) && isObject(target[key]) ? diffObjects(value, target[key]) : value
      }
    },
    {}
  )
}

export const promiseSerial = (funcs) =>
  funcs.reduce(
    (promise, func) => promise.then((result) => func().then(Array.prototype.concat.bind(result))),
    Promise.resolve([])
  )

export const isIntlPhoneNumber = (value) => {
  let regex = /^\+(?:[0-9]?){6,14}[0-9]$/
  return !!(!helpers.req(value) || regex.test(value))
}

export const money = (v, locale, currency = 'CAD') =>
  v ? v.toLocaleString(locale, { style: 'currency', currency }) : ''

export const filterToString = ({ field, operator, value }) => `${field}:${operator}:${value}`
export const toFilterString = (filterObject) =>
  filterObject ? filterObject.items.map(filterToString).join(filterObject.separator) : null

export const stampItem = (item) => {
  const stamp = new Date().getTime()
  return { ...item, stamp }
}

export const stampItems = (items) => {
  const stamp = new Date().getTime()
  return items.map((item) => ({ ...item, stamp }))
}
